import React from "react";
import PageHeader from "Components/PageHeader";
import ActionRow from "./ActionRow";
import { TEXT } from "./SkillsBridgerV2.constants";


const SkillsBridgerPageHeader = ({ onGroupSkillsMap, onGroupSkillsProficiency, loading, hasSelection }) => (
  <PageHeader
    title={TEXT.PAGE_TITLE}
    subtitle={TEXT.PAGE_DESCRIPTION}
    actions={
      <>
        <ActionRow label={TEXT.ACTION_SKILLS_MAP_LABEL} onClick={onGroupSkillsMap} disabled={loading || !hasSelection}>
          {TEXT.ACTION_SKILLS_MAP_BTN}
        </ActionRow>
        <ActionRow label={TEXT.ACTION_SKILLS_PROFICIENCY_LABEL} onClick={onGroupSkillsProficiency} disabled={loading || !hasSelection}>
          {TEXT.ACTION_SKILLS_PROFICIENCY_BTN}
        </ActionRow>
      </>
    }
  />
);

export default SkillsBridgerPageHeader;
